import { createSlice } from '@reduxjs/toolkit';
import { getAllActiveBanners } from './bannerServices';

const initialState = {
    allActiveBanners: {
        isBannersLoading: true,
        isBannersSuccess: null,
        bannerMessage: null,
        banners: []
    }
}

const bannerSlice = createSlice({
    name: 'banner',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getAllActiveBanners.pending, (state) => {
            state.allActiveBanners = {
                ...initialState.allActiveBanners,
                isBannersLoading: true,
                bannerMessage: 'Loading banners...'
            };
        })
        .addCase(getAllActiveBanners.rejected, (state, action) => {
            state.allActiveBanners = {
                ...initialState.allActiveBanners,
                isBannersLoading: false,
                isBannersSuccess: false,
                bannerMessage: action.payload
            };
        })
        .addCase(getAllActiveBanners.fulfilled, (state, action) => {
            state.allActiveBanners = {
                ...initialState.allActiveBanners,
                isBannersLoading: false,
                isBannersSuccess: true,
                bannerMessage: action.payload.message,
                banners: action.payload
            };
        })
    }
});

export default bannerSlice.reducer;